import * as React from 'react'
import { cn } from '@/registry/reapit/lib/utils'

// DS: fixed bottom strip, h-16 (64px), border-top, mobile-only (hidden on desktop via parent layout)
function BottomBar({ className, ...props }: React.ComponentProps<'nav'>) {
  return (
    <nav
      data-slot="bottom-bar"
      className={cn(
        'fixed bottom-0 left-0 right-0 z-50 flex h-16 items-center justify-around border-t border-border bg-background px-2',
        className,
      )}
      {...props}
    />
  )
}

type BottomBarItemProps = React.ComponentProps<'a'> & {
  icon: React.ReactNode
  active?: boolean
}

function BottomBarItem({ className, icon, active = false, children, ...props }: BottomBarItemProps) {
  return (
    <a
      data-slot="bottom-bar-item"
      aria-current={active ? 'page' : undefined}
      className={cn(
        // DS: gap-1 (4px) between icon and label — replaces old gap-0.5 (2px, off 4px grid)
        // DS: icon-md (20px) for bottom bar items; label is text-xs font-medium
        'flex flex-1 flex-col items-center justify-center gap-1 rounded-md py-1.5 text-xs font-medium transition-colors',
        active ? 'text-primary' : 'text-muted-foreground hover:text-foreground',
        className,
      )}
      {...props}
    >
      {/* DS: icon-md = 20px (size-5) for bottom bar icons per Principal policy */}
      <span className="size-5 [&>svg]:size-full">{icon}</span>
      {children && <span>{children}</span>}
    </a>
  )
}

export { BottomBar, BottomBarItem }
